/**
 * Tipuri partajate — larisa-si-dani
 * Se potrivesc cu schema Supabase (supabase/schema.sql)
 */

export type PhotoStatus = 'pending' | 'approved' | 'rejected';

/** Câmpuri photo din Supabase (DB) */
export interface PhotoRow {
  id: string;
  uploaded_by: string;
  uploader_uuid?: string | null;
  caption: string | null;
  telegram_file_id: string | null;
  telegram_file_ids: { file_id: string; width: number; height: number }[];
  telegram_message_id: number | null;
  telegram_channel: string | null;
  status: PhotoStatus;
  reviewed_by: string | null;
  reviewed_at: string | null;
  reject_reason: string | null;
  views_count: number;
  created_at: string;
}

/** Alias Photo pentru compatibilitate cu componente (MagazineGallery, etc.) */
export interface Photo {
  id: string;
  event_slug: string;
  uploader_name: string;
  uploader_uuid: string;
  width: number | null;
  height: number | null;
  size_bytes: number | null;
  status: PhotoStatus;
  uploaded_at: number;
  caption: string | null;
  likes_count: number;
  comments_count: number;
  views_count?: number;
  /** Telegram file_id (folosit pentru thumbnail pe web prin getFile) */
  telegram_file_id?: string | null;
  telegram_message_id?: number | null;
  telegram_channel?: string | null;
  /**
   * Daca exista, se foloseste ca src in loc de telegramFileUrl.
   * Folosit pentru cover photo locala (hero) care nu vine din Telegram.
   */
  static_url?: string | null;
  /**
   * Daca true, poza e marcata ca "hero" si e ne-interactiva
   * (nu se poate da like, comenta, marka view).
   */
  is_hero?: boolean;
}

/** Converteste PhotoRow (DB) → Photo (UI) */
export function rowToPhoto(row: PhotoRow, counts: { likes: number; comments: number; views?: number }): Photo {
  return {
    id: row.id,
    event_slug: 'larisa-si-dani',
    uploader_name: row.uploaded_by,
    uploader_uuid: '',
    width: null,
    height: null,
    size_bytes: null,
    status: row.status,
    uploaded_at: new Date(row.created_at).getTime(),
    caption: row.caption,
    likes_count: counts.likes,
    comments_count: counts.comments,
    views_count: counts.views ?? row.views_count ?? 0,
    telegram_file_id: row.telegram_file_id,
    telegram_message_id: row.telegram_message_id,
    telegram_channel: row.telegram_channel,
  };
}

export interface Comment {
  id: string;
  photo_id: string;
  author: string;
  body: string;
  created_at: string;
}

export interface Like {
  photo_id: string;
  user_token: string;
  created_at: string;
}

export interface Admin {
  id: string;
  unique_id: string;
  display_name: string;
  telegram_chat_id: number | null;
  created_at: string;
}
